//index.js

import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { AuthProvider } from "./contexts/AuthContext";
import { Bugfender } from "@bugfender/sdk";
import { VERSION } from "./version";
import { AnalyticsProvider } from "./analytics/AnalyticsProvider";

Bugfender.init({
  appKey: "Wuf4d16LpG1Nc18BtHpZFuUGvc6sNnHN",
  // overrideConsoleMethods: true,
  printToConsole: false,
  // registerErrorHandler: true,
  // logBrowserEvents: true,
  // logUIEvents: true,
  version: VERSION,
  // build: '',
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AnalyticsProvider>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </AnalyticsProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
